import { createIcon } from '@bonusly/design-system';

export const FishBowl = createIcon({
	displayName: 'FishBowl',
	viewBox: '0 0 244 180',
	path: (
		<g fill="none">
			<g clipPath="url(#clip0_4982_97905)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M209.928 179C214.841 179 219.501 176.629 222.022 172.412C232.177 155.422 238 135.629 238 114.5C238 51.2634 185.841 0 121.5 0C57.1588 0 5 51.2634 5 114.5C5 135.629 10.8231 155.422 20.9782 172.412C23.4986 176.629 28.159 179 33.0718 179H209.928ZM136.965 228H106.035C111.095 228.66 116.257 229 121.5 229C126.743 229 131.905 228.66 136.965 228Z"
					fill="#ECEDF3"
				/>
				<path
					opacity="0.2"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M53.806 51C51.747 51 50.0778 52.6692 50.0778 54.7282C50.0778 56.784 51.7418 58.4512 53.7964 58.4563H51.7176C37.6577 72.4147 28.9517 91.7587 28.9517 113.136C28.9517 141.041 43.7858 165.481 65.9985 179H146.002C168.215 165.481 183.049 141.041 183.049 113.136C183.049 91.7587 174.343 72.4147 160.283 58.4563H158.204C160.258 58.4512 161.922 56.784 161.922 54.7282C161.922 52.6692 160.253 51 158.194 51H53.806Z"
					fill="white"
				/>
				<circle cx="130" cy="178" r="12" fill="#3B4044" />
				<circle cx="218" cy="178" r="12" fill="#3B4044" />
				<path d="M134 121.526V163L167 134.777L141.84 117.411C138.523 115.122 134 117.496 134 121.526Z" fill="#3B4044" />
				<circle cx="174" cy="166" r="40" fill="#3B4044" />
				<ellipse cx="157" cy="147.5" rx="3" ry="3.5" fill="#0F1011" />
				<ellipse cx="188" cy="147.5" rx="3" ry="3.5" fill="#0F1011" />
				<path
					d="M172.486 153.691C172.802 153.881 173.198 153.881 173.514 153.691L174.904 152.857C175.774 152.336 175.404 151 174.39 151H171.61C170.596 151 170.226 152.336 171.096 152.857L172.486 153.691Z"
					fill="#0F1011"
				/>
				<path d="M214 120.769V167.5L179 134.5L206.254 116.59C209.579 114.405 214 116.79 214 120.769Z" fill="#3B4044" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M53.0002 51C50.791 51 49.0002 52.7909 49.0002 55C49.0002 56.6689 50.0222 58.099 51.4745 58.6987C37.5574 72.6383 28.9517 91.8822 28.9517 113.136C28.9517 141.041 43.7858 165.481 65.9985 179H146.002C168.215 165.481 183.049 141.041 183.049 113.136C183.049 91.8822 174.443 72.6383 160.526 58.6987C161.978 58.099 163 56.6689 163 55C163 52.7909 161.209 51 159 51H53.0002Z"
					fill="url(#paint0_linear_4982_97905)"
					fillOpacity="0.8"
				/>
				<g style={{ mixBlendMode: 'multiply' }}>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M46.5614 75.041C75.2283 87.3979 99.7081 89.4044 124.641 81.4472C139.696 76.6423 156.42 78.46 169.292 81.746C174.117 91.3186 176.835 102.136 176.835 113.587C176.835 139.242 163.197 161.711 142.776 174.14H69.2242C48.8029 161.711 35.165 139.242 35.165 113.587C35.165 99.3719 39.3526 86.1343 46.5614 75.041Z"
						fill="#ACCDFF"
					/>
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<path
						d="M68.5137 149.111C61.8977 160.204 69.892 170.326 74.7161 174H78.1619C77.0133 170.681 74.9918 163.049 76.0945 159.067C77.4728 154.089 86.7765 136.311 70.5812 126C72.6486 129.081 75.1296 138.018 68.5137 149.111Z"
						fill="#4CCF81"
					/>
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<path
						d="M75.0879 156.407C70.738 164.289 74.1817 171.42 76.4473 174H78.8262C78.2598 171.068 77.127 166.611 80.1855 160.981C82.6847 156.382 87.3221 150.074 86.9823 136C86.3026 143.389 80.5254 146.556 75.0879 156.407Z"
						fill="#4CCF81"
					/>
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<rect x="84" y="139" width="32" height="35" fill="#8897A0" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<rect x="84" y="135" width="5" height="4" fill="#8897A0" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<rect x="93" y="135" width="5" height="4" fill="#8897A0" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<rect x="102" y="135" width="5" height="4" fill="#8897A0" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<rect x="111" y="135" width="5" height="4" fill="#8897A0" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<path d="M93 157.5C93 153.358 96.3579 150 100.5 150C104.642 150 108 153.358 108 157.5V174H93V157.5Z" fill="#8897A0" />
				</g>
				<circle opacity="0.7" cx="116" cy="144" r="2" fill="white" />
				<circle opacity="0.7" cx="110" cy="150" r="1" fill="white" />
				<circle opacity="0.7" cx="86.5" cy="123.5" r="1.5" fill="white" />
				<circle opacity="0.7" cx="143.5" cy="100.5" r="1.5" fill="white" />
				<circle opacity="0.7" cx="64.5" cy="108.5" r="2.5" fill="white" />
				<path d="M156 59H54C62.8768 60 86.4591 62 109.773 62C133.088 62 150.305 60 156 59Z" fill="#0F1011" fillOpacity="0.04" />
			</g>
			<defs>
				<linearGradient id="paint0_linear_4982_97905" x1="97.0002" y1="109" x2="183" y2="199.5" gradientUnits="userSpaceOnUse">
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</linearGradient>
				<clipPath id="clip0_4982_97905">
					<rect width="244" height="180" rx="8" fill="white" />
				</clipPath>
			</defs>
		</g>
	),
});
